import { AxiosRequestConfig } from "axios";
import md5 from "md5";

import store from "@/store";

import { RequestConfig } from "@/interfaces/http/request-config";
import { RequestStackItem } from "@/interfaces/http/request-stack-item";

import { RequestInterceptor } from "@/types/http/request-interceptor";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * UI HTTP request interceptor.
 * It helps to determine whether any request is still pending,
 * so we can display appropriate information for user.
 */
export const uiRequestInterceptor: RequestInterceptor = {
  onFulfilled(
    value: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> | AxiosRequestConfig {
    // We create unique request id so we can track its progress later to determine
    // whether any request is currently pending.
    const requestId = md5(`${Date.now()}:${JSON.stringify(value)}`);

    // We set request id in request config object.
    // It will be accessible in response/error object too!
    (value as RequestConfig).requestId = requestId;

    // Propagate new request to Vuex
    store.dispatch("ui/pushRequestStackItem", {
      id: requestId,
      alias: (value as RequestConfig).requestAlias
    } as RequestStackItem);

    return value;
  }
};
